import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';
import { ConfiguracoesPage } from './configuracoes.page';
import { ConfiguracoesModel } from 'projects/core/src/lib/core/model/ConfiguracoesModel';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { TratamentoGatewayService } from 'projects/core/src/lib/core/TratamentoGatewayService';

export class ConfiguracoesViewModel {

    configuracoesModel = new ConfiguracoesModel()
    context: ConfiguracoesPage

    setContext(context: ConfiguracoesPage) {
        this.context = context
    }

    getContext(): ConfiguracoesPage {
        return this.context
    }

    async enviaOpcaoImpressaoDigital(impressaoDigital: Boolean) {
        let retorno = await this.configuracoesModel.enviaOpcaoImpressaoDigital(impressaoDigital)
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                this.getContext().mensagemSucessoAlteracao('Opção salva com sucesso!')
            } else {
                this.getContext().mensagemFalhaAlteracao('Não foi possível salvar sua opção. Tente novamente')
            }
        } catch (e) {}
    }

    async enviaOpcaoReconhecimentoFacial(reconhecimentoFacial: Boolean) {
        let retorno = await this.configuracoesModel.enviaOpcaoReconhecimentoFacial(reconhecimentoFacial)
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                this.getContext().mensagemSucessoAlteracao('Opção salva com sucesso!')
            } else {
                this.getContext().mensagemFalhaAlteracao('Não foi possível salvar sua opção. Tente novamente')
            }
        } catch (e) {}
    }

    async removeConta() {
        return await this.configuracoesModel.removeConta()
    }
}